import { makeRequest } from 'lib/api';
import { objectToUrlParams } from 'modules/core/utils/url';

import { ClientNotificationsControlRequest } from '../api/notificationsApi';

export const notificationsController = {
  getNotificationsHistory: (data = {}): Promise<any> => {
    return makeRequest('get', `/v1/notifications/clients/history?${ objectToUrlParams(data) }`);
  },
  updateNotificationsControl: (request: ClientNotificationsControlRequest): Promise<any> => {
    return makeRequest('put', `/v1/clients/notifications_control/${ request.clientId }`, request);
  },
};
